<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">【{{this.resData.cgRecordNo}}】<span style="color: #1890ff;">{{this.resData.goodName}}</span> 服务评价</span>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">客户服务评价</div>
        </div>

        <!-- 表单1 -->
        <FormInput
          style="margin-top: 10px;"
          class="form_component"
          :id="'formTwo'"
          ref="ruleForms"
          :label_width="'200px'"
          :Formlist="formlistTwo"
          :isCompile="isCompile"
        />

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">服务项目信息</div>
        </div>

        <!-- 表单2 -->
        <FormInput
          style="margin-top: 10px;"
          class="form_component"
          :id="'formOne'"
          ref="ruleForms"
          :label_width="'200px'"
          :Formlist="formlist"
          :isCompile="isCompile"
        />        
      </div>
    </div>

    <!-- 下白板按钮 -->
    <div class="blank-border">
      <a-button class="bottom-button" type="primary" ghost @click="cancle" >返回</a-button>
    </div>
  </div>
</template>
    
<script>
import {
  queryEvaInfoById
} from "@/api/api.js";
export default {
  name: "FtsTrustWebAddInvestment",
  components: {
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      isCompile: false, // 是否编辑
      formlist: [
        {
          row: 1,
          ishowNode: true,
          name: "cgRecordNo",
          lable: "服务单号",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "goodName",
          lable: "服务项目名称",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "custNo",
          lable: "客户编号",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "remCount",
          lable: "客户剩余项目数量",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "count",
          lable: "申请数量",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "networkName",
          lable: "服务地点",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "contacts",
          lable: "联系人",
          value: "1",
          type: "input",
        },
        {
          row: 1,
          ishowNode: true,
          name: "phone",
          lable: "联系电话",
          value: "1",
          type: "input",
        },
        {
          disabled: false,
          row: 2,
          ishowNode: true,
          name: "custRemark",
          lable: "服务订单客户备注",
          type: "textarea",
          value: "",
        },

      ],

      formlistTwo: [
        {
          disabled: false,
          row: 2,
          ishowNode: true,
          name: "evaluateContent",
          lable: "客户评价",
          type: "textarea",
          value: "",
        },
        {
          disabled: true,
          row: 2,
          ishowNode: true,
          name: "evaluateAll",
          lable: "评价星级",
          type: "rate",
          value: "",
        },
        {
          disabled: false,
          row: 2,
          ishowNode: true,
          name: "busId",
          lable: "图片",
          type: "imgList",
          value: [],
        },
      ],

      //响应结果
      resData: {},

    };
  },
  mounted() {
    //查询
    this.queryList();
  },
  methods: {
    //查询
    queryList() {
      queryEvaInfoById({
        id: this.$route.query.id,
        goodId: this.$route.query.goodId
      })
      .then(res => {
        if (res.code == "0000") {
          this.resData = res.content;

          // //表单1赋值
          this.formlistTwo[0].value = this.resData.evaluateContent;
          this.formlistTwo[1].value = this.resData.evaluateAll;
          this.resData.pictList.forEach(item => {
            this.formlistTwo[2].value.push(item.id);
          })

          //表单2赋值
          this.formlist[0].value = this.resData.cgRecordNo;
          this.formlist[1].value = this.resData.goodName;
          this.formlist[2].value = this.resData.custNo;
          this.formlist[3].value = this.resData.remCount;
          this.formlist[4].value = this.resData.count;
          this.formlist[5].value = this.resData.networkName;
          this.formlist[6].value = this.resData.contacts;
          this.formlist[7].value = this.resData.phone;
          this.formlist[8].value = this.resData.custRemark;


        }
      });
    },
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    border-bottom: 1px solid #e4e4e4;
    width: 100%;
    height: 50px;
    background: #fff;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    .nav-lspan {
      font-size: 16px;
      color: #999999;
      float: left;
      margin: 8px 8px 8px 8px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 83%;
    background: #fff;
    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 50px;
        background-color: #F6F6FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
  margin-left: 15px;
}
</style>